import { SlatePlugin } from '../../slatePlugins.types';
import { renderLeafStrikethrough } from './renderLeafStrikethrough';
import { StrikethroughPluginOptions } from './types';

export const StrikethroughReadOnlyPlugin = (options?: StrikethroughPluginOptions): SlatePlugin => ({
  renderLeaf: renderLeafStrikethrough(options),
});
